{
    document.addEventListener("DOMContentLoaded", function () {
        const swiperWrapper = document.querySelector(
            ".listIconSlider .swiper-wrapper"
        );
        const slide = swiperWrapper.querySelector(".swiper-slide");

        if (slide) {
            for (let i = 0; i < 10; i++) {
                let clone = slide.cloneNode(true);
                swiperWrapper.appendChild(clone);
            }
        }

        var swiper = new Swiper(".listIconSlider", {
            slidesPerView: "auto",
            loop: true,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            speed: 50000,
            breakpoints: {
                150: {
                    spaceBetween: 20,
                },
                576: {
                    spaceBetween: 20,
                },
                769: {
                    spaceBetween: 30,
                },
                1025: {
                    spaceBetween: 35,
                },
            },
        });
    });
}

// {
//     document.addEventListener("DOMContentLoaded", function () {
//         new Swiper(".testimonialSlider", {
//             effect: 'slide',
//             speed: 1000,
//             breakpoints: {
//                 280: {
//                     slidesPerView: 1.5,
//                     spaceBetween: 10,
//                 },
//                 576: {
//                     slidesPerView: 2.5,
//                     spaceBetween: 15,
//                 },
//                 769: {
//                     slidesPerView: 3,
//                     spaceBetween: 20,
//                 },
//                 1025: {
//                     slidesPerView: 3,
//                     spaceBetween: 20,
//                 }
//             }
//         });
//     });
// }

document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".testimonialSlider", {
        effect: 'slide',
        speed: 2000,
        // Enables free scrolling instead of snapping to slide positions
        // freeMode: {
        //     enabled: true,
        //     sticky: false,
        //     momentumRatio: 0.5,
        // },
        loop: true,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        breakpoints: {
            280: {
                slidesPerView: 1.5,
                spaceBetween: 10,
            },
            576: {
                slidesPerView: 2.5,
                spaceBetween: 15,
            },
            769: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1025: {
                slidesPerView: 3,
                spaceBetween: 20,
            }
        }
    });
});

{
    document.addEventListener("DOMContentLoaded", function () {
        new Swiper(".prodCardSlider", {
            effect: 'slide',
            speed: 1000,
            breakpoints: {
                280: {
                    slidesPerView: 1.5,
                    spaceBetween: 10,
                },
                576: {
                    slidesPerView: 2.5,
                    spaceBetween: 15,
                },
                769: {
                    slidesPerView: 3.1,
                    spaceBetween: 20,
                },
                1025: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                }
            }
        });
    });
}


{
    document.addEventListener("DOMContentLoaded", function () {
        new Swiper(".Recmd-sliders", {
            effect: 'slide',
            speed: 1000,
            spaceBetween:20,
            slidesPerView:1,
            navigation: {
                nextEl: '.btns_swiper-arrow.next',
                prevEl: '.btns_swiper-arrow.prev',
          },
        });
    });
}


{
    document.addEventListener("DOMContentLoaded", function () {
        const swiperWrapper = document.querySelector(
            ".listIconSlider .swiper-wrapper"
        );
        const slide = swiperWrapper.querySelector(".swiper-slide");

        if (slide) {
            for (let i = 0; i < 10; i++) {
                let clone = slide.cloneNode(true);
                swiperWrapper.appendChild(clone);
            }
        }

        var swiper = new Swiper(".listIconSlider", {
            slidesPerView: "auto",
            loop: true,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            speed: 10000,
            breakpoints: {
                150: {
                    spaceBetween: 20,
                },
                576: {
                    spaceBetween: 20,
                },
                769: {
                    spaceBetween: 30,
                },
                1025: {
                    spaceBetween: 35,
                },
            },
        });
    });
}